import React from 'react';
import classnames from 'classnames';

import { Member } from '../Member';
import { AddMembers } from '../AddMembers';

import styles from './GroupMembers.module.scss';
import { trackingGroupSelectMember } from 'services/analytics/interceptor/handlers/trackGroup';

interface GroupMembersProps {
  /** @User[] List of users */
  members: User[];
  /** @boolean If true then the members list should collapse  */
  collapsed?: boolean;
  /** @string id of the group */
  group?: Group;
  /** @boolean If it should render the AddMembers component */
  allowAddMembers?: boolean;
  /** @boolean If the group heading should render with an alternate style */
  alternateStyle?: boolean;
}

export const GroupMembers: React.FC<GroupMembersProps> = ({
  group,
  members,
  collapsed,
  allowAddMembers,
  alternateStyle
}) => {
  const onMemberClick = React.useCallback(
    (collaborator: User) => {
      if (group) {
        trackingGroupSelectMember({
          name: group!.name!,
          type: group!.groupType!,
          member: collaborator.email || collaborator.id!,
        });
      }
    },
    [group]
  );

  return (
    <div className={classnames(styles.member, { 
      [styles.collapsed]: collapsed, 
      [styles.alternate]: alternateStyle,
    })}>
      {/* Render member list */}
      {members.map((collaborator, key) => (
        <Member 
          key={key} 
          collaborator={collaborator} 
          onLinkClick={onMemberClick} 
          alternateStyle={alternateStyle}
        />
      ))}

      {/* Render add member field */}
      {allowAddMembers && <AddMembers alternateStyle={alternateStyle} memberCount={members.length || 0} group={group} />}
    </div>
  );
};

export default GroupMembers;
